<template lang="pug">
    footer
        a#topanchor(v-if="showAnchor" href="#not-fixed-menu")
            font-awesome-icon(class="icon" icon="arrow-alt-circle-up")
        nav#footer-menu(v-if="items && items.length")
            .container
                .logo.columns
                    img(src="~@/assets/logo.png")
                .infos.columns
                    .fragen.column
                        p Noch weitere Fragen?
                    .mail.column(v-if="footerText.email !== undefined")
                        p
                            font-awesome-icon(icon="envelope")
                            a(:href="emailLink")  {{ footerText.email }}
                .navi.columns
                  .copyright.column
                      p {{ footerText.text }}
                  .navi.column

                      tree-menu(:items="items" :max-depth="1" :allow-multiple-active-items="true" :delay="100")
        // #va-footer
        //    small.has-text-centered Erstellt mit CityPage, dem Webbaukasten der Vanameland
</template>

<script>

// import _ from 'lodash'
import get from 'lodash.get'
import cloneDeep from 'lodash.clonedeep'
import { mapGetters } from 'vuex'

import NestedSet from '@/nested-set-lib'

export default{
    name: 'Footer',
    data() {
        return {
            showAnchor: false,
            lastScrollPosition: 0
        }
    },
    mounted() {
        window.addEventListener('scroll', this.onScroll)
    },
    beforeDestroy() {
        window.removeEventListener('scroll', this.onScroll)
    },
    methods: {
        onScroll() {
            const currentScrollPosition = window.pageYOffset || document.documentElement.scrollTop
            if ( currentScrollPosition < 0) return
            if ( currentScrollPosition < 600 ) {
                this.showAnchor = false
            }else {
                // if ( Math.abs( currentScrollPosition - this.lastScrollPosition ) < 60) return
                this.showAnchor = currentScrollPosition > this.lastScrollPosition || currentScrollPosition < (this.lastScrollPosition + 300)
            }
            this.lastScrollPosition = currentScrollPosition
        }
    },
    computed: {
        items() {
            const menu = this.menus.find(menu => menu.key === 'footer-menu')
            let items = get(menu, 'menuItems') || []
            items = cloneDeep(items)

            if (items.length) {
                return NestedSet.createTree(items)
            }

            return items
        },
        baseUrl() {
            return window.location.host
        },
        currentYear() {
            return new Date().getFullYear()
        },
        footerText() {
            switch (this.baseUrl) {
                default:
                    return {
                        text: 'Angelgemeinschaft St.Hubert - Escheln, vormals Willich 1962 e.V. © ' + this.currentYear,
                        email: 'kontakt@angelverein-kempen.de',
                    }
            }
        },
        emailLink() {
            return 'mailto:' + this.footerText.email
        },
        phoneLink() {
            return 'tel:' + this.footerText.phone
        },
        ...mapGetters({
            menus: 'menus',
            config: 'config',
        })
    },
}
</script>

<style lang="sass" scoped>

    @import "~bulma/sass/utilities/mixins"
    @import '~@/assets/sass/variables'
    footer
        background-color: #efefe8
        color: #000
        position: relative
        margin-top: 50px
        #topanchor
            position: fixed
            bottom: 50px
            right: 50px
            padding: 15px 25px
            border-radius: 5px
            font-size: 24px
            background-color: $primary
            color: #fff
            +mobile
                display: none
        nav#footer-menu::v-deep
            a
                color: #000
            ul
                & > li
                    text-align: center
                    a
                        display: block
                        padding: 10px 20px
                +desktop
                    display: flex
                    & > li
                        flex-grow: 1
                        flex-basis: 100%
                        text-transform: uppercase
                        border-right: 1px solid #2B1A06
                        &:last-child
                            border-right: none
                        a
                            height: 100px
                            display: flex
                            justify-content: center
                            align-items: center
            .logo
              display: flex
              margin-top: 20px
              margin-bottom: 20px
              align-items: center
              justify-content: center
              img
                  max-width: 100px
                  @include mobile
                      max-width: 50px
                      //- max-width: 360px;
            .copyright
                text-align: center
                p
                    color: #888
            .infos
                p
                    color: #888
                    font-weight: bold
                .fragen
                    text-align: right
                .telefon
                    text-align: center
            .navi
                margin: 0
            .tree-menu
                width: 75%
                .tree-item a
                    color: #888
                    height: 25px
                    font-size: 90%
                    font-weight: bold
            @include until($desktop)
                .fragen
                    text-align: center !important
                .telefon
                    text-align: center
                .mail
                    text-align: center
                .tree-menu
                    width: 100%
        div#va-footer
            font-size: .8rem
            padding: 4px
            text-align: center
            background-color: rgba(0, 0, 0, .2)
            +desktop
                background-color: initial
                font-size: .9rem
                position: absolute
                bottom: 100%
                color: #4c4c4c
                width: 100%
                text-align: center
</style>
